import { render, staticRenderFns } from "./PickBackground.vue?vue&type=template&id=009bb953&"
import script from "./PickBackground.vue?vue&type=script&lang=js&"
export * from "./PickBackground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports